import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import MypageleftArea from '../../component/MypageleftArea';
import consts from '../../libs/consts';


import { getBase64, getMemberinfo } from "../../utils/utils";


import * as APIS from "../../utils/service";
import Radios from '../../component/Radios';
import AddrSelector from '../../component/AddrSelector';
import Select from '../../component/Select';
import Checkbox from '../../component/Checkbox';

export default function Contactus({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const selectFile = useRef(null);
    const selectFile2 = useRef(null);
    const { configdata } = useSelector(s => s.configReducer);

    const [memberinfos, setmemberinfos] = useState('');
    const [lists, setlists] = useState([]);
    const [writeflag, setwriteflag] = useState(false);
    const [errmsg, seterrmsg] = useState(['', '']);

    const [title, settitle] = useState('');
    const [desc, setdesc] = useState('');
    const [selnoticeidx, setselnoticeidx] = useState('');
    const [uidx, setuidx] = useState('');
    const [files, setfiles] = useState([]);

    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return { names: x?.title, values: x?.idx }
    })
    
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        let title = x?.title;

        if(x?.category_1 == 1 && x?.title == '오피스텔') title = '주거용 오피스텔';
        if(x?.category_1 == 2 && x?.title == '오피스텔') title = '업무용 오피스텔';

        return { names: title, values: x?.idx, category_1: x?.category_1 }
    })

    let firstCategorys = configdata?.consts?.category_1_OptionConsts?.find((x, i) => i === 0)?.idx;
    const [category_1, setcategory_1] = useState(0);
    const [category_1_OptionConsts, setcategory_1_OptionConsts] = useState(category_1_setting);
    const [category_2_OptionConsts, setcategory_2_OptionConsts] = useState(category_2_setting);
    const [category_2, setcategory_2] = useState(0);

    const [minizoomlevel, setminizoomlevel] = useState(1);
    const [miniorderselviewtype, setminiorderselviewtype] = useState(0);
    const [miniorderbuyviewtype, setminiorderbuyviewtype] = useState(0);
    const [miniordersteps, setminiordersteps] = useState([]);
    const [miniorderbuttonText, setminiorderbuttonText] = useState('간편 문의');
    const [miniorderbuttonTexterror, setminiorderbuttonTexterror] = useState('');
    const [minicustombanner, setminicustombanner] = useState(0);
    const [minipcbanner, setminipcbanner] = useState('');
    const [minimobilebanner, setminimobilebanner] = useState('');
    const [minipcbannerfiles, setminipcbannerfiles] = useState({});
    const [minimobilebannerfiles, setminimobilebannerfiles] = useState({});

    const [cityspopflag, setcityspopflag] = useState(false);
    const [listselecterviewerlist, setlistselecterviewerlist] = useState([]);
    const [seldamdang, setseldamdang] = useState('');
    const [damdanglist, setdamdanglist] = useState([]);
    const [checkvalues, setcheckvalues] = useState([]);
    const [allCheckValues, setallCheckValues] = useState([]);



    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);
    useEffect(() => {
        setcategory_1(memberinfos?.compony?.minicategory_1);
        setcategory_2(memberinfos?.compony?.minicategory_2);
        setminiorderbuttonText(memberinfos?.compony?.miniorderbuttonText);
        setminicustombanner(memberinfos?.compony?.minicustombanner * 1);
        setminiorderselviewtype(memberinfos?.compony?.miniorderselviewtype * 1);
        setminiorderbuyviewtype(memberinfos?.compony?.miniorderbuyviewtype * 1);
        setminizoomlevel(memberinfos?.compony?.minizoomlevel * 1);
        setminipcbannerfiles({
            name: memberinfos?.compony?.minipcbanner
        });
        setminimobilebannerfiles({
            name: memberinfos?.compony?.minimobilebanner
        });
        setminiordersteps(!memberinfos?.compony?.miniordersteps ? [] : JSON.parse(memberinfos?.compony?.miniordersteps));
        let excategory_2 = memberinfos?.compony?.minicategory_2?.split(',');
        if (excategory_2?.length > 0) {
            setcheckvalues(category_2_setting?.filter(item => excategory_2.includes(item?.values.toString())));
        }
    }, [memberinfos]);
    useEffect(() => {
        let sender = {}
        APIS.postData('/v1/master/users', sender).then(({ data }) => {
            if (data) {
                //setdamdanglist(data);
                console.log(data);
                let damdanglistArr = [];
                data?.map((x, i) => {
                    if(x?.level*1 > 2){
                        return;
                    }
                    damdanglistArr.push({ labels: `${x?.name} ${x?.rank}`, values: x?.idx });
                })
                setdamdanglist(damdanglistArr);
                setseldamdang(damdanglistArr[0]?.values);

            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
        });
    }, []);


    useEffect(() => {
        seterrmsg(errmsg?.map((xe, ie) => ''));

    }, [title, desc]);

    useEffect(() => {
        listopen();
    }, []);
    const listopen = () => {
        // dispatch(loadingflas({ loading: true }));
        // let sender = {}
        // APIS.postData('/v1/cs/list', sender).then(({ data }) => {
        //     if(data){
        //         console.log(data);
        //         setlists(data);
        //     }
        // }).catch(({ response }) => {
        //     const { data } = response;
        // }).finally(() => {
        //     dispatch(loadingflas({ loading: false }));
        // });           
    }

    const componyUpdateFunc = (cnames = '', values = '', files = 0) => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            cname: cnames,
            updatevalues: values,
            filestype: files
        }
        APIS.postData('/v1/compony/miniOptionUpdate', sender).then(({ data }) => {
            if (data) {
                getMemberinfo(setmemberinfos);
            }
        }).catch(({ response }) => {
            const { data } = response;
            console.log(data);
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }


    return (
        <>
            <Layout header={false} actives={''}>
                <div className='mypagearea'>
                    <div >
                        <MypageleftArea pages={6} />
                    </div>
                    <div
                        className='padding32'
                        style={{
                            display: 'flex', flexDirection: 'column', gap: 20
                        }}
                    >
                        <div
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            }}
                        >
                            <div className='pagetitle fontsize20 bolds'>외부 광고 설정</div>
                            <Button
                                buttonTxt={'내 미니홈'}
                                styles={{
                                    width: 120, height: 40, fontSize: 14, borderRadius: 100
                                }}
                                onPress={() => {
                                    window.open(window.location.origin + '/' + memberinfos?.compony?.company_phone, '_blank');
                                }}
                            />
                        </div>
                        <div className='pagetabs margint20'>
                            <button onClick={() => { navigate('/Setoutside') }}>아싸점포거래소</button>
                            <button className='active' onClick={() => { navigate('/Setminihome') }}>미니홈</button>
                        </div>
                        
                        <div className='mypageinputsarea' style={{ gap: 16 }}>
                            <div className='fontsize16 bolds' style={{ width: '100%', textAlign: 'left' }}>홈페이지 기본화면 설정</div>
                            <div>
                                {/* <div className="inputtextviewtype2 ">
                                <div>매물 종류 기본 설정</div>
                                <div>
                                    <Radios
                                        linetype={'radioimg'}
                                        values={category_1}
                                        setvalues={(e) => {
                                            setcategory_1(e*1);
                                            setcategory_2(e*1 === 0 ? 0 : category_2_setting?.filter((x2, i2) => (x2.category_1*1 === e*1))[0]?.values);
                                            componyUpdateFunc('minicategory_1', e*1);
                                            componyUpdateFunc('minicategory_2', 0);
                                        }} 
                                        namevalue={[{names: '전체', values: 0}, ...category_1_OptionConsts]}
                                        fontweights={400}
                                        fontSizes={14}
                                        sizes={20}
                                    />
                                </div>
                            </div>  */}
                                <div className="inputtextviewtype2 margint8">
                                    <div>매물 종류 기본 설정</div>
                                    <div>
                                        <div style={{ marginBottom: 12 }}>
                                            <Checkbox
                                                linetype={'checkimg'}
                                                values={allCheckValues}
                                                setvalues={(e) => {
                                                    if (e.length > 0) {
                                                        //전체보기 선택시 기존 선택리스트 없에기 - j
                                                        setcheckvalues([]);
                                                        componyUpdateFunc('minicategory_2', '');
                                                    }
                                                    setallCheckValues(e)
                                                }}
                                                namevalue={[{ names: "전체보기", values: "전체보기" }]}
                                                fontweights={400}
                                                fontSizes={14}
                                                sizes={20}
                                            />
                                        </div>
                                        <Checkbox
                                            linetype={'checkimg'}
                                            values={checkvalues}
                                            setvalues={(e) => {
                                                // console.log(e.map(v => v.values).toString());
                                                setcheckvalues(e);
                                                componyUpdateFunc('minicategory_2', e.map(v => v.values).toString());
                                                if(e.length > 0){
                                                    setallCheckValues([]) //종류 선택시 전체보기 비활성 - j
                                                }
                                            }}
                                            namevalue={category_2_setting}
                                            fontweights={400}
                                            fontSizes={14}
                                            sizes={20}
                                        />
                                        {/* <Radios
                                        linetype={'checkimg'}
                                        values={category_2}
                                        setvalues={(e) => {
                                            setcategory_2(e*1);
                                            componyUpdateFunc('minicategory_2', e*1);
                                        }}
                                        namevalue={
                                            category_1*1 === 0 ? 
                                                [{names: '전체', values: 0, category_1: 0}] 
                                            : 
                                                [{names: '전체', values: 0, category_1: category_1, category_2: 0}, ...category_2_setting?.filter((x, i) => x?.category_1*1 === category_1*1)]
                                        }
                                        fontweights={400}
                                        fontSizes={14}
                                        sizes={20}
                                    /> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ height: 1, backgroundColor: '#eee' }} />
                        <div className='mypageinputsarea' style={{ gap: 16 }}>
                            <div className='fontsize16 bolds' style={{ width: '100%', textAlign: 'left' }}>지도 설정</div>
                            <div>
                                <div className="inputtextviewtype2 ">
                                    <div>최대 확대 축척 제한</div>
                                    <div>
                                        <Radios
                                            linetype={'radioimg'}
                                            values={minizoomlevel}
                                            setvalues={(e) => {
                                                setminizoomlevel(e * 1);
                                                componyUpdateFunc('minizoomlevel', e * 1);
                                            }}
                                            namevalue={[
                                                { names: '20m', values: 1 },
                                                { names: '30m', values: 2 },
                                                { names: '50m', values: 3 },
                                                { names: '100m', values: 4 },
                                                { names: '250m', values: 5 },
                                            ]}
                                            fontweights={400}
                                            fontSizes={14}
                                            sizes={20}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ height: 1, backgroundColor: '#eee' }} />
                        <div className='mypageinputsarea' style={{ gap: 16 }}>
                            <div className='fontsize16 bolds' style={{ width: '100%', textAlign: 'left' }}>미니홈 간편 문의 접수 권한</div>
                            <div>
                                <div className="inputtextviewtype2 ">
                                    <div>매수/임차 의뢰</div>
                                    <div>
                                        <Radios
                                            linetype={'radioimg'}
                                            values={miniorderselviewtype}
                                            setvalues={(e) => {
                                                setminiorderselviewtype(e * 1);
                                                componyUpdateFunc('miniorderselviewtype', e * 1);
                                            }}
                                            namevalue={[
                                                { names: '대표가 모두 접수', values: 0 },
                                                { names: '해당 매물 담당자가 접수', values: 1 },
                                            ]}
                                            fontweights={400}
                                            fontSizes={14}
                                            sizes={20}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="inputtextviewtype2 ">
                                    <div>매도/임대 의뢰</div>
                                    <div>
                                        <Radios
                                            linetype={'radioimg'}
                                            values={miniorderbuyviewtype}
                                            setvalues={(e) => {
                                                setminiorderbuyviewtype(e * 1);
                                                componyUpdateFunc('miniorderbuyviewtype', e * 1);
                                            }}
                                            namevalue={[
                                                { names: '대표가 모두 접수', values: 0 },
                                                { names: '해당 매물 담당자가 접수', values: 1 },
                                            ]}
                                            fontweights={400}
                                            fontSizes={14}
                                            sizes={20}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="inputtextviewtype2 ">
                                    <div></div>
                                    <div style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                                        <div>
                                            <Button
                                                buttonTxt={'지역별 담당자 설정'}
                                                styles={{
                                                    width: 140, height: 32, fontSize: 14,
                                                }}
                                                onPress={() => {
                                                    setlistselecterviewerlist([]);
                                                    setcityspopflag(true);
                                                }}
                                            />
                                        </div>
                                        <div className='margint8' style={{ textAlign: 'left' }}>
                                            <p>담당 지역이 중복되면 등록 된 담당자 모두에게 접수됩니다.</p>
                                            <p>지역별 담당자 설정은 <span className='bolds colorF00'>미니홈의 문의 접수에만 적용</span>되며,</p>
                                            <p>직접 접수·등록하는 매물·고객과는 무관하니 참고하시기 바랍니다.</p>
                                        </div>
                                        {miniordersteps?.length > 0 &&
                                            <div className="margint20" style={{ width: '100%', padding: 10, border: '1px solid #DDD', borderRadius: 12 }}>
                                                <div
                                                    className='membercontrolarea'
                                                >
                                                    <div style={{ width: '100%' }}>
                                                        <div className="productlist_th">
                                                            <div style={{ width: 120 }}>이름</div>
                                                            <div style={{ width: 200 }}>담당지역</div>
                                                            <div style={{ width: 120 }}>관리</div>
                                                        </div>
                                                        {miniordersteps?.map((x, i) => {
                                                            //console.log(x);
                                                            return (
                                                                <div
                                                                    key={i}
                                                                    className="productlist_td"
                                                                >
                                                                    <div style={{ width: 120, gap: 4 }}>
                                                                        {damdanglist?.find(item => item?.values * 1 === x?.userIdx * 1)?.labels}
                                                                    </div>
                                                                    <div style={{ width: 200 }}>
                                                                        {x?.areas?.map(item => item.viewernames)?.join(", ")}
                                                                    </div>
                                                                    <div style={{ width: 120, display: 'flex', gap: 8 }}>
                                                                        <Button
                                                                            className={'linenormalbutton'}
                                                                            buttonTxt={'수정'}
                                                                            styles={{
                                                                                width: 48, height: 24, fontSize: 12,
                                                                            }}
                                                                            onPress={() => {
                                                                                setseldamdang(x?.userIdx * 1);
                                                                                setlistselecterviewerlist(x?.areas);
                                                                                setcityspopflag(true);
                                                                            }}
                                                                        />
                                                                        <Button
                                                                            className={'normalbutton'}
                                                                            buttonTxt={'삭제'}
                                                                            styles={{
                                                                                width: 48, height: 24, fontSize: 12,
                                                                                backgroundColor: '#666'
                                                                            }}
                                                                            onPress={() => {
                                                                                componyUpdateFunc('miniordersteps', JSON.stringify(miniordersteps?.filter(item => item?.userIdx * 1 !== x?.userIdx * 1)));
                                                                            }}
                                                                        />
                                                                    </div>

                                                                </div>
                                                            );
                                                        })}

                                                    </div>
                                                </div>
                                            </div>}
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div style={{ height: 1, backgroundColor: '#eee' }} />
                        <div className='mypageinputsarea' style={{ gap: 16 }}>
                            <div className='fontsize16 bolds' style={{ width: '100%', textAlign: 'left' }}>기타</div>
                            <div>
                                <div className="inputtextviewtype2 ">
                                    <div className='margint10'>간편 문의 버튼 텍스트 변경</div>
                                    <div>
                                        <Input
                                            className={`inputs`}
                                            placeholder="텍스트를 입력해주세요."
                                            setValue={setminiorderbuttonText}
                                            value={miniorderbuttonText}
                                            name="mb_phone"
                                            msg={'최대 8자 이내로 입력해 주세요.'}
                                            withButton={'저장'}
                                            withButtonLong={true}
                                            withstyle={{
                                                width: 120
                                            }}
                                            withButtonPress={() => {
                                                if (!miniorderbuttonText) {
                                                    setminiorderbuttonTexterror('버튼 텍스트를 입력해주세요.');
                                                    return;
                                                }
                                                componyUpdateFunc('miniorderbuttonText', miniorderbuttonText);
                                            }}
                                            error={miniorderbuttonTexterror}
                                            errClear={() => {
                                                setminiorderbuttonTexterror('');
                                            }}
                                            maxlength={8}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="inputtextviewtype2 ">
                                    <div className='margint10'>커스텀 배너 설정</div>
                                    <div>
                                        <Radios
                                            linetype={'radioimg'}
                                            values={minicustombanner}
                                            setvalues={(e) => {
                                                setminicustombanner(e * 1);
                                                componyUpdateFunc('minicustombanner', e * 1);
                                            }}
                                            namevalue={[
                                                { names: '활성화', values: 1 },
                                                { names: '비활성화', values: 0 },
                                            ]}
                                            fontweights={400}
                                            fontSizes={14}
                                            sizes={20}
                                        />
                                    </div>
                                </div>
                                <div className="inputtextviewtype2 margint12">
                                    <div></div>
                                    <div style={{ gap: 8 }}>
                                        <div style={{ width: 'calc(100% - 129px)' }}>
                                            <Input
                                                className={`inputs`}
                                                readOnly={true}
                                                style={{
                                                    backgroundColor: '#F1F1F1'
                                                }}
                                                placeholder="파일을 업로드해주세요."
                                                setValue={setminiorderbuttonText}
                                                value={!minipcbannerfiles?.name ? '파일을 업로드해주세요.' : minipcbannerfiles?.name}
                                                name="mb_phone"
                                                headermsg={'PC(사이즈: 200px * 800px)'}
                                                withButtonclassName={'lineinputwithButton'}
                                                withButton={'찾기'}
                                                withButtonLong={true}
                                                withstyle={{
                                                    width: 120, height: 40
                                                }}
                                                withButtonPress={() => {
                                                    selectFile.current.click();
                                                }}
                                            />
                                        </div>
                                        <Button
                                            buttonTxt={'저장'}
                                            styles={{
                                                width: 120, height: 40, fontSize: 14, marginTop: 22
                                            }}
                                            onPress={() => {
                                                componyUpdateFunc('minipcbanner', minipcbannerfiles, 1);
                                            }}
                                        />
                                        <input type='file' ref={selectFile} style={{ display: 'none' }} onChange={(e) => {
                                            let file = e.target.files[0];
                                            getBase64(file).then(result => {
                                                file["base64"] = result;
                                                file["ext"] = file.name?.split('.')[1];
                                                setminipcbannerfiles({
                                                    name: file?.name,
                                                    base: result,
                                                    ext: file.name?.split('.')[1]
                                                });
                                            })
                                                .catch(err => { console.log(err); });
                                        }} />
                                    </div>
                                </div>
                                <div className="inputtextviewtype2 margint12">
                                    <div></div>
                                    <div style={{ gap: 8 }}>
                                        <div style={{ width: 'calc(100% - 129px)' }}>
                                            <Input
                                                className={`inputs`}
                                                readOnly={true}
                                                style={{
                                                    backgroundColor: '#F1F1F1'
                                                }}
                                                placeholder="파입을 업로드해주세요."
                                                setValue={setminiorderbuttonText}
                                                value={!minimobilebannerfiles?.name ? '파일을 업로드해주세요.' : minimobilebannerfiles?.name}
                                                name="mb_phone"
                                                headermsg={'모바일(사이즈: 600px * 300px)'}
                                                withButtonclassName={'lineinputwithButton'}
                                                withButton={'찾기'}
                                                withButtonLong={true}
                                                withstyle={{
                                                    width: 120, height: 40
                                                }}
                                                withButtonPress={() => {
                                                    selectFile2.current.click();
                                                }}
                                            />
                                        </div>
                                        <Button
                                            buttonTxt={'저장'}
                                            styles={{
                                                width: 120, height: 40, fontSize: 14, marginTop: 22
                                            }}
                                            onPress={() => {
                                                componyUpdateFunc('minimobilebanner', minimobilebannerfiles, 1);
                                            }}
                                        />
                                    </div>
                                    <input type='file' ref={selectFile2} style={{ display: 'none' }} onChange={(e) => {
                                        let file = e.target.files[0];
                                        getBase64(file).then(result => {
                                            file["base64"] = result;
                                            file["ext"] = file.name?.split('.')[1];
                                            setminimobilebannerfiles({
                                                name: file?.name,
                                                base: result,
                                                ext: file.name?.split('.')[1]
                                            });
                                        })
                                            .catch(err => { console.log(err); });
                                    }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
            {cityspopflag === true &&
                <div className='PopupArea'>
                    <div>
                        <div className='PopupAreaBG'
                        //onClick={() => { setcityspopflag(false); }}
                        />
                        <div className='PopupAreaContents' style={{ width: 800 }}>
                            <div>
                                <div className="popTitle padding20">
                                    <span >희망지역</span>
                                    <button
                                        onClick={() => {
                                            setcityspopflag(false);
                                        }}
                                    >
                                        <img src="./images/icons/x.svg" width='20' />
                                    </button>
                                </div>
                                <div className="padding32">
                                    <div className='popcontents'>
                                        <div style={{ width: '100%' }}>
                                            <div>
                                                <div className="inputtextviewtype2 " style={{ justifyContent: 'flex-start' }}>
                                                    <div className='margint10' style={{ width: 80 }}>담당자</div>
                                                    <div>
                                                        <Select
                                                            setValues={setseldamdang}
                                                            values={seldamdang}
                                                            selectData={damdanglist}
                                                            divwidth={{
                                                                width: 200
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ fontWeight: 700, marginTop: 10 }}>
                                                    *사무소 대표님은 별도의 담당 지역을 설정할 수 없으며, 전지역 의뢰매물을 확인하실 수 있습니다.
                                                </div>
                                                <div className="filteraddrarea margint20">
                                                    <AddrSelector
                                                        setcityspopflag={setcityspopflag}
                                                        listselecterviewerlist={listselecterviewerlist}
                                                        setlistselecterviewerlist={setlistselecterviewerlist}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='selstickdelarea margint20' >
                                        {listselecterviewerlist?.length > 0 && listselecterviewerlist?.map((x, i) => {
                                            return (
                                                <button
                                                    type="button" key={i}
                                                    onClick={() => {
                                                        setlistselecterviewerlist(listselecterviewerlist?.filter(item => item?.viewernames !== x?.viewernames));
                                                    }}
                                                >
                                                    {x?.viewernames}
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M3.52851 3.52851C3.78886 3.26816 4.21097 3.26816 4.47132 3.52851L7.99992 7.05711L11.5285 3.52851C11.7889 3.26816 12.211 3.26816 12.4713 3.52851C12.7317 3.78886 12.7317 4.21097 12.4713 4.47132L8.94273 7.99992L12.4713 11.5285C12.7317 11.7889 12.7317 12.211 12.4713 12.4713C12.211 12.7317 11.7889 12.7317 11.5285 12.4713L7.99992 8.94273L4.47132 12.4713C4.21097 12.7317 3.78886 12.7317 3.52851 12.4713C3.26816 12.211 3.26816 11.7889 3.52851 11.5285L7.05711 7.99992L3.52851 4.47132C3.26816 4.21097 3.26816 3.78886 3.52851 3.52851Z" fill="#999999" />
                                                    </svg>
                                                </button>
                                            );
                                        })}
                                    </div>
                                    <div className="filterlines" style={{ margin: 0, marginTop: 20 }}></div>
                                    <div className='popbuttons'>
                                        <div style={{ width: '70%' }}>
                                            <Button
                                                buttonTxt={'저장하기'}
                                                onPress={() => {
                                                    let listset = miniordersteps;
                                                    let ckerdam = miniordersteps?.find(item => item?.userIdx * 1 === seldamdang * 1);
                                                    if (ckerdam?.userIdx * 1 > 0) {
                                                        //수정
                                                        listset?.map((x, i) => {
                                                            if (x?.userIdx * 1 === seldamdang * 1) {
                                                                x.areas = listselecterviewerlist;
                                                                return x;
                                                            } else {
                                                                return x;
                                                            }
                                                        });
                                                    } else {
                                                        //console.log(seldamdang, listselecterviewerlist);
                                                        listset.push({
                                                            userIdx: seldamdang,
                                                            areas: listselecterviewerlist
                                                        });
                                                        //추가
                                                    }
                                                    //console.log(listset);
                                                    //return;

                                                    //setminiordersteps(listset);
                                                    setcityspopflag(false);
                                                    componyUpdateFunc('miniordersteps', JSON.stringify(listset));
                                                }}
                                            />
                                        </div>
                                        <div style={{ width: '30%' }}>
                                            <Button
                                                className={'linenormalbutton'}
                                                buttonTxt={'초기화'}
                                                titleimgs={`./images/icons/loop-left-line-purple.svg`}
                                                onPress={() => {
                                                    setlistselecterviewerlist([]);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            }

        </>
    )
}

